class EditorialEnhancements {
  constructor() {
    this.bindGridControls();
    this.rememberProduct();
    this.renderRecentlyViewed();
    this.bindQuickView();
    this.bindShippingEstimator();
  }

  bindGridControls() {
    const savedSize = localStorage.getItem('editorial-collection-grid');
    this.setGridSize(savedSize || 'standard');
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-editorial-grid-size]');
      if (!button) return;
      this.setGridSize(button.dataset.editorialGridSize);
    });
  }

  setGridSize(size) {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;
    grid.dataset.editorialGridSize = size;
    localStorage.setItem('editorial-collection-grid', size);
    document.querySelectorAll('[data-editorial-grid-size]').forEach((button) => {
      const selected = button.dataset.editorialGridSize === size;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  rememberProduct() {
    const source = document.querySelector('[data-editorial-current-product]');
    if (!source) return;
    try {
      const product = JSON.parse(source.textContent);
      const history = JSON.parse(localStorage.getItem('editorial-recent-products') || '[]')
        .filter((item) => item.handle !== product.handle);
      history.unshift(product);
      localStorage.setItem('editorial-recent-products', JSON.stringify(history.slice(0, 8)));
    } catch (_) {}
  }

  renderRecentlyViewed() {
    const target = document.querySelector('[data-editorial-recently-viewed]');
    if (!target) return;
    try {
      const max = Number(target.dataset.editorialRecentlyViewed) || 4;
      const products = JSON.parse(localStorage.getItem('editorial-recent-products') || '[]').slice(1, max + 1);
      if (!products.length) return;
      target.innerHTML = products.map((product) => `
        <article class="editorial-recent-card">
          <a href="${product.url}"><img src="${product.image}" alt="${product.title}" loading="lazy"></a>
          <a href="${product.url}" class="editorial-recent-card__title">${product.title}</a>
          <p>${product.price}</p>
        </article>`).join('');
      target.closest('.editorial-recent')?.removeAttribute('hidden');
    } catch (_) {}
  }

  bindQuickView() {
    document.addEventListener('click', async (event) => {
      const trigger = event.target.closest('[data-editorial-quick-view]');
      if (!trigger) return;
      event.preventDefault();
      const dialog = this.getQuickViewDialog();
      const content = dialog.querySelector('[data-editorial-quick-view-content]');
      content.innerHTML = '<p>Loading…</p>';
      dialog.showModal();
      try {
        const url = new URL(trigger.dataset.productUrl, window.location.origin);
        url.pathname += '.js';
        const product = await fetch(url).then((response) => response.json());
        const variants = product.variants.filter((variant) => variant.available);
        const selected = variants[0];
        content.innerHTML = `
          <div class="editorial-quick-view__grid">
            <img src="${product.featured_image}" alt="${product.title}">
            <div><p class="editorial-eyebrow">Quick view</p><h2>${product.title}</h2><p>${this.money(selected.price)}</p>
            <form data-editorial-quick-view-form>
              <label for="EditorialVariant">Choose a variant</label>
              <select id="EditorialVariant" name="id">${variants.map((variant) => `<option value="${variant.id}">${variant.title}</option>`).join('')}</select>
              <button class="button" type="submit">Add to cart</button>
            </form><a class="editorial-link" href="${product.url}">View full product</a></div>
          </div>`;
      } catch (_) {
        content.innerHTML = '<p>Unable to load this product. Please use the product page.</p>';
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-editorial-quick-view-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      button.disabled = true;
      try {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: form.id.value, quantity: 1 }) });
        window.location.assign('/cart');
      } catch (_) {
        button.disabled = false;
        button.textContent = 'Try again';
      }
    });
  }

  getQuickViewDialog() {
    let dialog = document.querySelector('#EditorialQuickView');
    if (dialog) return dialog;
    document.body.insertAdjacentHTML('beforeend', '<dialog id="EditorialQuickView" class="editorial-quick-view"><button class="editorial-quick-view__close" aria-label="Close" data-editorial-close-quick-view>×</button><div data-editorial-quick-view-content></div></dialog>');
    dialog = document.querySelector('#EditorialQuickView');
    dialog.addEventListener('click', (event) => { if (event.target === dialog || event.target.closest('[data-editorial-close-quick-view]')) dialog.close(); });
    return dialog;
  }

  money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: 'INR' }).format(cents / 100); }

  bindShippingEstimator() {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-editorial-shipping-estimator]');
      if (!form) return;
      event.preventDefault();
      const output = form.querySelector('[data-editorial-shipping-result]');
      const zip = form.querySelector('[name="zip"]').value.trim();
      if (!zip) return;
      output.textContent = 'Checking delivery options…';
      const address = new URLSearchParams({ 'shipping_address[zip]': zip, 'shipping_address[country]': form.dataset.country || 'IN' });
      try {
        await fetch(`/cart/prepare_shipping_rates.json?${address}`, { method: 'POST' });
        const result = await fetch(`/cart/async_shipping_rates.json?${address}`).then((response) => response.json());
        output.textContent = result.shipping_rates?.length ? result.shipping_rates.map((rate) => `${rate.name}: ${rate.price}`).join(' · ') : 'Rates will be confirmed at checkout.';
      } catch (_) { output.textContent = 'Rates will be confirmed at checkout.'; }
    });
  }
}

new EditorialEnhancements();
